import { render, staticRenderFns } from "./PortfolioSearchSelect.vue?vue&type=template&id=2da4a088&scoped=true&"
import script from "./PortfolioSearchSelect.vue?vue&type=script&lang=js&"
export * from "./PortfolioSearchSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da4a088",
  null
  
)

export default component.exports